import { render, staticRenderFns } from "./IncoursePVWantingList.vue?vue&type=template&id=4b51d3d9&"
import script from "./IncoursePVWantingList.vue?vue&type=script&lang=js&"
export * from "./IncoursePVWantingList.vue?vue&type=script&lang=js&"
import style0 from "./IncoursePVWantingList.vue?vue&type=style&index=0&id=4b51d3d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports